import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaFilePdf, FaDownload } from 'react-icons/fa'; // Import icons
import "../../../styles/pages-styles/main-dashboard-pages-styles/texbook-style/TextBook.css";

const TextBook = () => {
  const [textbooks, setTextbooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTextbooks = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get("/user/fetch-textbooks");
        setTextbooks(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTextbooks();
  }, []);

  if (loading) {
    return <div>Loading textbooks...</div>;
  }

  if (error) {
    return <div>Error loading textbooks: {error}</div>;
  }

  return (
    <div className="textbook-container">
      <h1 className="textbook-heading">Get Your Textbooks</h1>

      <div className="table-container">
        <table className="textbook-table">
          <thead>
            <tr>
              <th>TextBook</th>
              <th>Description</th>
              <th>Actions</th> {/* Changed to "Actions" */}
            </tr>
          </thead>
          <tbody>
            {textbooks.map((book) => (
              <tr key={book._id}>
                <td className="book-title">{book.name}</td>
                <td className="book-description">{book.description}</td>
                <td className="book-actions"> {/* New container for buttons */}
                  <a
                    href={book.pdfLink}
                    className="view-button" // New class for view button
                    target="_blank"
                    rel="noopener noreferrer"
                    title="View PDF"
                  >
                    <FaFilePdf /> {/* PDF icon */}
                  </a>
                  <a
                    href={book.pdfLink.replace("/upload/", "/upload/fl_attachment/")}
                    className="download-button"
                    download={`${book.name}.pdf`} // Suggest a filename for download
                    title="Download PDF"
                    target="_blank" 
                    rel="noopener noreferrer" 
                  >
                    <FaDownload /> {/* Download icon */}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TextBook;
